import { browserSessionStorage } from "@/react/lib/browserStorage";

const STORAGE_KEY = "circle-ai-masquerading-allowed-member";

// Keep only the currently allowed community member ID, never a history of opt-ins.
export const getCircleAiMasqueradingSession = (): string | null =>
  browserSessionStorage.getItem(STORAGE_KEY);

export const setCircleAiMasqueradingSession = (
  communityMemberId: string | null,
) => {
  if (communityMemberId) {
    browserSessionStorage.setItem(STORAGE_KEY, communityMemberId);
  } else {
    browserSessionStorage.removeItem(STORAGE_KEY);
  }
};
